module.exports = __webpack_public_path__ + "img/logo.17b2545b.jpeg";